import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { fade, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 0,
    flexShrink: 0,
    borderRadius: 2,
    lineHeight: '10px',
    fontSize: theme.typography.pxToRem(10),
    height: 20,
    minWidth: 20,
    whiteSpace: 'nowrap',
    padding: theme.spacing(1.5, 1.5),
    cursor: 'default',
    fontWeight: theme.typography.fontWeightBold,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  primary: {
    color: theme.palette.primary.main,
    backgroundColor: fade(theme.palette.primary.main, 0.08),
  },
  secondary: {
    color: theme.palette.secondary.main,
    backgroundColor: fade(theme.palette.secondary.main, 0.08),
  },
  error: {
    color: theme.palette.error.main,
    backgroundColor: fade(theme.palette.error.main, 0.08),
  },
  success: {
    color: theme.palette.success.main,
    backgroundColor: fade(theme.palette.success.main, 0.08),
  },
  warning: {
    color: theme.palette.warning.main,
    backgroundColor: fade(theme.palette.warning.main, 0.08),
  },
  grey: {
    color: theme.palette.common.black,
    backgroundColor: fade(theme.palette.grey[700], 0.08),
  },
}));

function Label({ className, color, children, style, variant = 'contained', ...rest }) {
  const classes = useStyles();

  const rootClassName = clsx(
    classes.root,
    {
      [classes[color]]: color,
    },
    className
  );

  const finalStyle = { ...style };

  if (variant === 'outlined') {
    finalStyle.backgroundColor = 'transparent';
    if (color === 'success') {
      finalStyle.color = '#3ad29f';
      finalStyle.border = '1px solid #3ad29f';
    } else if (color === 'warning') {
      finalStyle.color = '#ffa500';
      finalStyle.border = '1px solid #ffa500';
    } else if (color === 'error') {
      finalStyle.color = '#AF4C4C';
      finalStyle.border = '1px solid #AF4C4C';
    } else {
      finalStyle.color = '#FFF';
      finalStyle.border = '1px solid #FFF';
    }
  }

  return (
    <span className={rootClassName} style={finalStyle} {...rest}>
      {children}
    </span>
  );
}

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.oneOf(['primary', 'secondary', 'error', 'warning', 'success']),
};

Label.defaultProps = {
  className: '',
  color: 'secondary',
};

export default Label;
